// extracted by mini-css-extract-plugin
export default {"wrapper":"RqQYPgQJKGQEAhQ629E+zg==","mainInner":"Ymef9aD8ePAWmYi36e9udg==","asideWrapper":"ysCNH8k1JpS0XhuFVPkTYQ=="};